var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9963 8.82081C18.8871 4.40202 14.4058 1.71909 9.98704 2.82831C6.53385 3.69517 4.02646 6.6797 3.76811 10.2306C1.31621 10.635 -0.343691 12.9504 0.0606558 15.4023C0.420101 17.5821 2.30886 19.1784 4.51803 19.1696H8.26762V17.6698H4.51803C2.86136 17.6698 1.51836 16.3268 1.51836 14.6701C1.51836 13.0135 2.86136 11.6705 4.51803 11.6705C4.93222 11.6705 5.26794 11.3347 5.26794 10.9205C5.2642 7.19302 8.28294 4.16823 12.0105 4.16453C15.2372 4.16129 18.0148 6.44245 18.639 9.60818C18.7006 9.92427 18.9571 10.1657 19.2764 10.2081C21.3266 10.5001 22.7519 12.3987 22.46 14.4489C22.1978 16.2898 20.626 17.6605 18.7665 17.6698H15.7668V19.1696H18.7665C21.6656 19.1609 24.0088 16.8035 24 13.9043C23.9926 11.491 22.3408 9.39352 19.9963 8.82081Z",
    fill: "#004EFF",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.484 11.89L8.48438 14.8896L9.54176 15.947L11.2666 14.2297V21.4214H12.7664V14.2297L14.4837 15.947L15.5411 14.8896L12.5414 11.89C12.2489 11.5992 11.7766 11.5992 11.484 11.89Z",
    fill: "#004EFF",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploading);
export default __webpack_public_path__ + "static/media/uploading.4cd33ce88b0ec751e319707a0be6d711.svg";
export { ForwardRef as ReactComponent };